const HistoryIdIcon = ({ className }) => (
  <svg
    className={className}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 11.375C3.036 11.375 0.625 8.964 0.625 6C0.625 3.036 3.036 0.625 6 0.625C8.964 0.625 11.375 3.036 11.375 6C11.375 8.964 8.964 11.375 6 11.375ZM6 1.375C3.4495 1.375 1.375 3.4495 1.375 6C1.375 8.5505 3.4495 10.625 6 10.625C8.5505 10.625 10.625 8.5505 10.625 6C10.625 3.4495 8.5505 1.375 6 1.375ZM6.375 8.25V5.96448C6.375 5.75748 6.207 5.58948 6 5.58948C5.793 5.58948 5.625 5.75748 5.625 5.96448V8.25C5.625 8.457 5.793 8.625 6 8.625C6.207 8.625 6.375 8.457 6.375 8.25ZM6.51001 4.25C6.51001 3.974 6.28651 3.75 6.01001 3.75H6.005C5.729 3.75 5.50745 3.974 5.50745 4.25C5.50745 4.526 5.73401 4.75 6.01001 4.75C6.28601 4.75 6.51001 4.526 6.51001 4.25Z"
      fill="white"
    />
  </svg>
);

export default HistoryIdIcon;
